import {Directive} from "@angular/core";
import {AbstractControl, NG_VALIDATORS, ValidationErrors, Validator} from "@angular/forms";
import {SessionModel} from "../../orchestration/session.model";
import {FieldValidationMessage} from "../field/field-validation-message";

@Directive({
    selector: "[woa-sms-phone-number]",
    providers: [{provide: NG_VALIDATORS, useExisting: SmsPhoneNumberDirective, multi: true}]
})
export class SmsPhoneNumberDirective implements Validator {

    constructor(private sessionModel: SessionModel) {
    }

    validate(control: AbstractControl): ValidationErrors | null {
        return control.value && !this.sessionModel.isValidMobileNumberForSms(control.value)
            ? [new FieldValidationMessage("woa-sms-phone-number", "woa.validation.common.smsPhoneNumber")]
            : [];
    }
}



// WEBPACK FOOTER //
// ./src/app/inputs/phone-number-field/sms-phone-number.directive.ts